import { compose, mdsWidget } from 'dojo/_base/declare';
import domStyle from 'dojo/dom-style';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import _TemplatedMixin from 'dijit/_TemplatedMixin';
import template from './Icon.html?raw';

class Icon extends compose(_WidgetBaseSP, _TemplatedMixin) {
    [key: string]: any;

    templateString: any = template;
    onChange: any = function () { };

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    _onClick_Tooltip(evt: any): void {
        this.emit("tooltip_click");
        //evt.stopPropagation();
    }

    clear(): void {
        (this.tooltip as any).innerHTML = "";
    }

    unSelect(): void {

    }
    getSelectedValues(): any {
        return {
            tooltip: (this.tooltip as any).innerHTML
        };
    }

    show(): void {
        domStyle.set(this.icon, "display", "inline");
    }

    hide(): void {
        domStyle.set(this.icon, "display", "none");
    }
}
Icon.prototype.declaredClass = 'more.Legacy.Zal.Icon';

export default mdsWidget(Icon);
